/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ExtensionsStructure } from './ExtensionsStructure';
import type { FaresParamStructure } from './FaresParamStructure';
import type { LineDirectionFilterStructure } from './LineDirectionFilterStructure';
import type { OperatorFilterStructure } from './OperatorFilterStructure';
import type { PtModeFilterStructure } from './PtModeFilterStructure';

export type TripParamStructure = {
  ptModeFilter?: PtModeFilterStructure;
  lineFilter?: LineDirectionFilterStructure;
  operatorFilter?: OperatorFilterStructure;
  noSingleStep?: boolean;
  noStairs?: boolean;
  noEscalator?: boolean;
  noElevator?: boolean;
  noRamp?: boolean;
  levelEntrance?: boolean;
  bikeTransport?: boolean;
  walkSpeed?: number;
  numberOfResults?: number;
  numberOfResultsBefore?: number;
  numberOfResultsAfter?: number;
  ignoreRealtimeData?: boolean;
  immediateTripStart?: boolean;
  interchangeLimit?: number;
  algorithmType?: TripParamStructure.algorithmType;
  itModesToCover?: Array<'WALK' | 'CYCLE' | 'TAXI' | 'SELF_DRIVE_CAR' | 'OTHERS_DRIVE_CAR' | 'MOTORCYCLE' | 'TRUCK'>;
  includeTrackSections?: boolean;
  includeLegProjection?: boolean;
  includeTurnDescription?: boolean;
  includeAccessibility?: boolean;
  includeIntermediateStops?: boolean;
  includeFares?: boolean;
  includeOperatingDays?: boolean;
  faresParam?: FaresParamStructure;
  extension?: ExtensionsStructure;
};

export namespace TripParamStructure {
  export enum algorithmType {
    FASTEST = 'FASTEST',
    MIN_CHANGES = 'MIN_CHANGES',
    LEAST_WALKING = 'LEAST_WALKING',
    LEAST_COST = 'LEAST_COST',
  }
}
